import { EnvironmentProviders, Injectable, Injector, LOCALE_ID, NgModule, Provider, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { configServiceFactory } from '@shared/config/config.service.factory';
import { ConfigService } from '@shared/services';
import { SharedModule } from '@shared/shared.module';
import { NavigationModule } from '../modules/navigation/navigation.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfoMessageModule } from '../modules/info-message/info-message.module';
import { KeycloakBearerInterceptor, KeycloakService } from 'keycloak-angular';
import { NoPermissionComponent } from './components/no-permission/no-permission.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {Observable} from 'rxjs';

registerLocaleData(localeDe);

// Small wrapper interceptor to skip keycloak-interceptor if keycloak is disabled
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	private keycloakInterceptor?: KeycloakBearerInterceptor;

	constructor(
		private injector: Injector,
		private configService: ConfigService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const config = this.configService.getConfig();

		// Wenn Config noch nicht geladen → einfach weiterleiten
		if (!config) {
			return next.handle(req);
		}

		// Wenn Keycloak deaktiviert → nichts machen
		if (!config.keycloak.enabled) {
			return next.handle(req);
		}

		// Wenn aktiviert → Keycloak-Interceptor faul initialisieren und delegieren
		if (!this.keycloakInterceptor) {
			this.keycloakInterceptor = this.injector.get(KeycloakBearerInterceptor);
		}

		return this.keycloakInterceptor.intercept(req, next);
	}
}

@NgModule({ declarations: [
        AppComponent,
        NoPermissionComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        NavigationModule,
        InfoMessageModule], providers: [
        { provide: LOCALE_ID, useValue: 'de' },
        KeycloakBearerInterceptor,
        provideAppInitializer(() => {
        const initializerFn = (configServiceFactory)(inject(ConfigService), inject(KeycloakService));
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
